<template>
  <div class="method-choose landing-wrapper">
    <h2 class="method-choose__title landing-title">
      {{ $t('actions.chooseMethod') }}
    </h2>
    <div class="method-choose__list">
      <template v-for="item in methods">
        <MethodCard :key="item.title" :card="item" :non-active="!item.available" @click="handleClick(item)" />
      </template>
    </div>

    <Calculator v-model="robux" />

    <Button
      class="method-choose__submit"
      size="xl"
      left-icon="/slider/shopping-bag.svg"
      @click="$router.push({ path: transferPath, query: { robux: queryRobux } })"
    >
      {{ $t('actions.buyRobux') }}
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Base/Button/Button.vue'
import MethodCard from '@/components/MethodCard/MethodCard.vue'
import Calculator from '@/components/Calculator/Calculator.vue'
import { mapGetters } from 'vuex'

import Purchase from '@/enums/Purchase'
import { PURCHASE_PATHS } from '@/utils/purchase'

export default {
  name: 'MethodChoose',
  components: { Calculator, MethodCard, Button },
  data() {
    return {
      robux: 0
    }
  },
  computed: {
    ...mapGetters(['rates', 'isPacksAvailable']),

    // Список методов постоянный: недоступный метод не исчезает, а гаснет
    // (RBXGD-1109). Пока карточку прятали, пришедший за паками не понимал,
    // есть метод на сайте или нет, а блок менял форму с сетки 2x2 на ряд из
    // трёх. Флаг available у каждого метода, а не только у паков: механизм
    // должен работать одинаково, если отвалится любой другой.
    methods() {
      return [
        {
          title: this.$t('gift.title'),
          benefits: [this.$t('gift.benefits.1'), this.$t('gift.benefits.2')],
          image: require('@/assets/images/methods/choose-gift.svg'),
          link: { path: PURCHASE_PATHS.gift },
          course: 'Выгодный курс',
          icon: require('@/assets/images/methods/gift-box.svg'),
          available: true
        },
        {
          title: this.$t('transfer.title'),
          benefits: [this.$t('transfer.benefits.1'), this.$t('transfer.benefits.2')],
          image: require('@/assets/images/methods/choose-transfer.svg'),
          link: { path: PURCHASE_PATHS.transfer },
          course: `КУРС 1₽ = ${this.rates.transfer} R$`,
          icon: require('@/assets/images/methods/coin.svg'),
          available: true
        },
        {
          title: this.$t('superPass.purchase.title'),
          benefits: [this.$t('superPass.benefits.1'), this.$t('superPass.benefits.2')],
          image: require('@/assets/images/methods/choose-super-pass.svg'),
          link: { path: PURCHASE_PATHS.superPass },
          course: `КУРС 1₽ = ${this.rates.superPass} R$`,
          icon: require('@/assets/images/methods/fire.svg'),
          available: true
        },
        {
          title: this.$t('packs.title'),
          benefits: [this.$t('packs.benefits.1'), this.$t('packs.benefits.2')],
          image: require('@/assets/images/methods/choose-packs.webp'),
          link: { path: PURCHASE_PATHS.packs },
          course: this.packsCourse,
          icon: require('@/assets/images/methods/packs-badge.svg'),
          // Логпасс включается и выключается у поставщика. Флаг реактивный, из
          // стора, поэтому карточка оживает без релиза, как только метод вернут.
          available: this.isPacksAvailable
        }
      ]
    },
    queryRobux() {
      return this.robux > Purchase.MAX_TO_BUY ? Purchase.MAX_TO_BUY : this.robux
    },
    transferPath: () => PURCHASE_PATHS.transfer,
    // Курс паков приходит одним числом в ₽ (валюта поставщика), поэтому
    // до его загрузки показываем нейтральную подпись.
    packsCourse() {
      return this.rates.packs ? `КУРС 1₽ = ${this.rates.packs} R$` : this.$t('packs.course')
    }
  },
  methods: {
    handleClick(item) {
      if (!item || !item.available) return
      this.$router.push(item.link)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './method-choose';
</style>
